import { render, staticRenderFns } from "./changePass.vue?vue&type=template&id=76d14dd6&scoped=true"
import script from "./changePass.vue?vue&type=script&lang=js"
export * from "./changePass.vue?vue&type=script&lang=js"
import style0 from "./changePass.vue?vue&type=style&index=0&id=76d14dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d14dd6",
  null
  
)

export default component.exports